/**
 * Returns a callback that triggers a custom event with
 * data provided by the getEventData function.
 * @param {Element} component
 * @param {string} eventType
 * @param {Function} [getEventData]
 * @returns {Function} A callback function
 */
const handleEventMap = (component, eventType, getEventData) => () => {
    const eventData = getEventData ? getEventData(component) : {};
    $(component).trigger(eventType, [eventData]);
};

export default handleEventMap;



// WEBPACK FOOTER //
// ./src/scripts/components/common/handleEventMap.js